import { date } from "@/helpers/time";
import { formatCalendarDate } from "../contracts/columns";
import { formatDocument } from "../screenings/columns";
import { Claim, ClaimStatus } from "./types";

export const claimStatusLabels: Record<ClaimStatus, string> = {
  reported: "Reclamada",
  dismissed: "Desistida",
  active: "Obligación",
  closed: "Cerrada",
};

export const formatPeriod = (period: string) =>
  date(`${period}-01`).format("MMM YYYY");

export const formatPeriodLong = (period: string) =>
  date(`${period}-01`).format("MMMM YYYY");

export const formatPeriods = (periods: string[]) =>
  periods.map(formatPeriod).join(", ");

export const CLAIM_TABLE_COLUMNS = [
  {
    key: "contractNumber",
    label: "Reclamación",
    width: "1fr",
    minWidth: 140,
    exportTransform: (claim: Claim) => claim.contractNumber,
  },
  {
    key: "tenantDocumentNumber",
    label: "Documento",
    width: "1fr",
    minWidth: 150,
    exportTransform: formatDocument,
  },
  {
    key: "tenantName",
    label: "Inquilino",
    width: "2fr",
    minWidth: 200,
    exportTransform: (claim: Claim) => claim.tenantName,
  },
  {
    key: "reportedPeriods",
    label: "Meses",
    width: "1fr",
    minWidth: 160,
    exportTransform: (claim: Claim) => formatPeriods(claim.reportedPeriods),
  },
  {
    key: "amount",
    label: "Valor",
    width: "1fr",
    minWidth: 130,
    exportTransform: (claim: Claim) => claim.amount,
  },
  {
    key: "createdAt",
    label: "Reclamada",
    width: "1fr",
    minWidth: 130,
    exportTransform: (claim: Claim) => formatCalendarDate(claim.createdAt),
  },
  {
    key: "status",
    label: "Estado",
    width: "1fr",
    minWidth: 120,
    exportTransform: (claim: Claim) => claimStatusLabels[claim.status],
  },
] as const;
